import cdnApi from './api-cdn';
import accountApi from './account';
import walletApi from './wallet';
import countryApi from './country';
import regionalApi from './regional';

const pluginAPI = {
	install(Vue) {
		Vue.prototype.$cdnAPI = cdnApi;
		Vue.prototype.$AccountAPI = accountApi;
		Vue.prototype.$WalletAPI = walletApi;
		Vue.prototype.$countryAPI = countryApi;
		Vue.prototype.$regionalAPI = regionalApi;
	},
};

export default pluginAPI;
